import { apiService } from "../api";

export const getTimeline = async (programId: string) => {
  const response = await apiService({
    url: `/program/${programId}/timeline`,
    method: "get",
    protectedRoute: true,
  });
  return response;
}
